import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/hooks/use-toast'
import { checkWebinarAdminKey, webinarStorage } from '@/services/webinarApi'

export default function WebinarAdminLogin() {
  const [key, setKey] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()
  const { toast } = useToast()

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!key.trim()) return

    setSubmitting(true)
    const ok = await checkWebinarAdminKey(key.trim())
    setSubmitting(false)

    if (!ok) {
      toast({
        title: 'Clé incorrecte',
        description: 'Vérifiez la clé partagée par LinkAfric.',
        variant: 'destructive',
      })
      return
    }

    webinarStorage.setKey(key.trim())
    navigate('/inscriptions-admin', { replace: true })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md border border-border p-8">
        <h1 className="text-2xl font-bold text-bronze mb-2">
          Suivi des inscriptions Webinaire
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          MAIN × LinkAfric · PI-SPI · Zone UEMOA
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="admin-key">Clé d'accès</Label>
            <Input
              id="admin-key"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              autoFocus
              autoComplete="off"
              placeholder="Saisir la clé partagée"
            />
          </div>

          <Button
            type="submit"
            disabled={submitting || !key.trim()}
            className="w-full bg-gold hover:bg-gold/90 text-white font-semibold rounded-full py-5"
          >
            {submitting ? 'Vérification…' : 'Se connecter'}
          </Button>
        </form>

        <p className="mt-8 text-xs text-muted-foreground text-center">
          Cette clé est partagée par LinkAfric. En cas de perte, contactez{' '}
          <a href="mailto:contact@linkafric.com" className="text-bronze underline">
            contact@linkafric.com
          </a>
          .
        </p>
      </div>
    </div>
  )
}
